(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var S = window.__MP = window.__MP || {};

  function cfg(sid){
    if(S[sid]) return S[sid];
    var el = document.querySelector('[data-mp-cfg="'+sid+'"]');
    if(!el) return null;
    var c;
    try { c = JSON.parse(el.textContent); } catch(e){ return null; }
    c.tier = 1;
    c.slots = {};
    S[sid] = c;
    var root = document.querySelector('[data-mp="'+sid+'"]');
    var onTier = root && root.querySelector('.tier.on');
    c.tier = onTier ? parseInt(onTier.getAttribute('data-mp-tier'), 10) : 1;
    var gpBox = root && root.querySelector('[data-mp-gp]');
    c.autoMix = !!(gpBox && gpBox.getAttribute('data-auto-mix') === '1');
    return c;
  }

  function root(sid){ return document.querySelector('[data-mp="'+sid+'"]'); }
  /* Learns decimals, separators, prefix and suffix from a Liquid-rendered sample
     (100000 cents = 1000.00) so JS totals render exactly like the Liquid `money` filter. */
  function shape(sample){
    var m = /[\d][\d.,'  ]*\d|\d/.exec(sample || '');
    if(!m) return {pre:'', suf:' ', dec:2, ds:'.', ts:','};
    var num = m[0];
    var tail = /([.,])(\d{1,4})$/.exec(num);
    var ds = tail ? tail[1] : '.';
    var dec = tail ? tail[2].length : 0;
    var whole = tail ? num.slice(0, -(dec + 1)) : num;
    var tsm = /[^\d]/.exec(whole);
    return {
      pre: sample.slice(0, m.index),
      suf: sample.slice(m.index + num.length),
      dec: dec, ds: ds, ts: tsm ? tsm[0] : ''
    };
  }
  function money(cents, sample){
    var s = shape(sample);
    var v = (Math.abs(cents) / 100).toFixed(s.dec).split('.');
    var whole = s.ts ? v[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + s.ts) : v[0];
    /* round amounts read cleaner: $60, not $60.00 */
    if(s.dec && Math.abs(cents) % 100 === 0) return s.pre + whole + s.suf;
    return s.pre + whole + (s.dec ? s.ds + v[1] : '') + s.suf;
  }

  /* ---------- gallery ---------- */
  window.mpSet = function(sid, i){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    var main = r.querySelector('#mpMain-'+sid), wrap = r.querySelector('#mpThumbs-'+sid);
    if(!main || !wrap) return;
    var th = wrap.children;
    if(i < 0) i = th.length - 1;
    if(i >= th.length) i = 0;
    main.src = c.images[i] || th[i].src;
    for(var k=0;k<th.length;k++) th[k].classList.toggle('on', k===i);
    wrap.setAttribute('data-idx', i);
    if(th[i].scrollIntoView) th[i].scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'});
  };
  window.mpStep = function(sid, d){
    var wrap = document.querySelector('#mpThumbs-'+sid); if(!wrap) return;
    mpSet(sid, parseInt(wrap.getAttribute('data-idx')||'0',10) + d);
  };

  /* ---------- tiers + variant slots ---------- */
  /* A tier can sell its own set of variants (option value in data-pack, e.g.
     "2-Month Bundle"), so a bundle-priced variant is only ever picked inside its tier. */
  function tierVars(c, tier){
    var pk = tier ? (tier.getAttribute('data-pack') || '') : '';
    if(!pk) return c.variants;
    var f = c.variants.filter(function(v){ return v.o2 === pk || v.o1 === pk; });
    return f.length ? f : c.variants;
  }
  function vt(v){ if(!v) return ''; return v.o2 ? v.o1 : v.title; }
  function renderSlots(sid){
    var c = cfg(sid), r = root(sid); if(!c || !r || !c.hasVariants) return;
    var wrap = r.querySelector('[data-mp-vp]'); if(!wrap) return;
    var box = wrap.querySelector('[data-mp-slots]');
    var tier = r.querySelector('[data-mp-tier="'+c.tier+'"]'); if(!tier) return;
    var n = c.tier;
    var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
    c.slots[n] = c.slots[n] || [];
    c.slots[n].length = qty;
    var tv = tierVars(c, tier), j, a;
    /* forget picks that belong to another tier's variants */
    for(j=0;j<qty;j++){
      var keep = false;
      for(a=0;a<tv.length;a++) if(String(tv[a].id) === String(c.slots[n][j])) keep = true;
      if(!keep) c.slots[n][j] = undefined;
    }
    /* the tier sells a single variant (e.g. "Single" vs "2-Pack Deal" packs): nothing to choose */
    var av1 = tv.filter(function(x){ return x.available; });
    if(av1.length === 1){
      for(a=0;a<qty;a++) c.slots[n][a] = av1[0].id;
      box.innerHTML = '';
      wrap.hidden = true;
      closePick(r);
      return;
    }
    /* one of each flavour, nothing to choose: fill the slots and hide the picker */
    if(wrap.getAttribute('data-auto-fill') === '1'){
      var av = tv.filter(function(x){ return x.available; });
      if(av.length === qty){
        for(a=0;a<qty;a++) c.slots[n][a] = av[a].id;
        box.innerHTML = '';
        wrap.hidden = true;
        closePick(r);
        return;
      }
    }
    var slotStyle = wrap.getAttribute('data-mp-style') === 'slots';

    var html = '';
    for(var i=0;i<qty;i++){
      var v = byId(c, c.slots[n][i]);
      if(slotStyle){
        html += '<button type="button" class="mp-slot-box'+(v?' filled':'')+'" data-i="'+i+'" '+
                'onclick="mpOpen(\''+sid+'\','+i+')" aria-label="'+(v ? vt(v) : 'Choose flavour '+(i+1))+'">'+
                (v ? ((v.img ? '<img src="'+v.img+'" alt="">' : '') + '<b>'+vt(v)+'</b>'+
                      '<span class="mp-slot-note">1/1 &#10003; · tap to change</span>')
                   : '<span class="plus">+</span>'+
                     '<span class="mp-slot-lbl">'+(qty>1 ? 'Bundle '+(i+1)+' flavor' : 'Choose your flavor')+'</span>'+
                     '<span class="mp-slot-note">0/1</span>') +
                '</button>';
      } else {
        html += '<button type="button" class="mp-cir'+(v?' filled':'')+'" data-i="'+i+'" '+
                'onclick="mpOpen(\''+sid+'\','+i+')" aria-label="'+(v ? vt(v) : 'Choose '+c.optionName)+'">'+
                '<span class="mp-cir-in">'+ (v
                    ? (v.img ? '<img src="'+v.img+'" alt="">' : '<b>'+vt(v).charAt(0)+'</b>')
                    : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>') +
                '</span><em>'+ (v ? vt(v) : (qty>1 ? '#'+(i+1) : 'Pick')) +'</em></button>';
      }
    }
    box.innerHTML = html;
    wrap.hidden = false;
    var head = wrap.querySelector('[data-mp-vp-h]');
    head.textContent = slotStyle ? '' : c.optionName + (qty > 1 ? ' — pick ' + qty : '');
    head.hidden = slotStyle;
    box.style.gridTemplateColumns = 'repeat(' + Math.min(qty, 3) + ',minmax(0,1fr))';
    closePick(r);
  }

  function byId(c, id){
    if(!id) return null;
    for(var k=0;k<c.variants.length;k++) if(String(c.variants[k].id) === String(id)) return c.variants[k];
    return null;
  }
  function closePick(r){
    var p = r.querySelector('[data-mp-pick]');
    if(p){ p.hidden = true; p.innerHTML = ''; }
    var m = r.querySelector('[data-mp-modal]');
    if(m) m.hidden = true;
    r.querySelectorAll('.mp-cir,.mp-slot-box').forEach(function(b){ b.classList.remove('open'); });
  }
  window.mpClosePick = function(sid){ var r = root(sid); if(r) closePick(r); };

  /* Tapping a circle reveals the flavour list right beneath the row, so the
     picker costs no vertical space until it is actually needed. */
  window.mpOpen = function(sid, i){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    var pick = r.querySelector('[data-mp-pick]');
    var btn  = r.querySelector('.mp-cir[data-i="'+i+'"], .mp-slot-box[data-i="'+i+'"]');
    if(!pick || !btn) return;
    var modal = r.querySelector('[data-mp-modal]');
    if(btn.classList.contains('open')){ closePick(r); return; }
    closePick(r);
    btn.classList.add('open');
    var cur = c.slots[c.tier][i];
    var tvs = tierVars(c, r.querySelector('[data-mp-tier="'+c.tier+'"]'));
    pick.innerHTML = tvs.map(function(v){
      return '<button type="button" class="mp-opt'+(String(cur)===String(v.id)?' on':'')+'"'+
        (v.available ? '' : ' disabled') +
        ' onclick="mpChoose(\''+sid+'\','+i+','+v.id+')">'+
        (v.img ? '<img src="'+v.img+'" alt="">' : '') +
        '<span>'+vt(v)+'</span>'+(v.available?'':'<small>Sold out</small>')+'</button>';
    }).join('');
    pick.hidden = false;
    if(modal){
      var qtyNow = (c.slots[c.tier]||[]).length || 1;
      var t = modal.querySelector('[data-mp-modal-title]');
      var sb = modal.querySelector('[data-mp-modal-sub]');
      if(t) t.textContent = qtyNow > 1 ? 'Select the flavor for Bundle ' + (i+1) : 'Choose your flavor';
      if(sb) sb.innerHTML = 'Pick <b>1 of ' + tvs.length + '</b> (' + (cur ? '1' : '0') + '/1)';
      modal.hidden = false;
    }
  };

  window.mpChoose = function(sid, i, vid){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    c.slots[c.tier][i] = vid;
    renderSlots(sid);
    /* Advance to the next empty circle so picking 3 flavours is three taps. */
    var next = -1;
    for(var k=0;k<c.slots[c.tier].length;k++) if(!c.slots[c.tier][k]){ next = k; break; }
    if(next > -1) mpOpen(sid, next);
  };

  window.mpTier = function(sid, n){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    c.tier = n;
    r.querySelectorAll('[data-mp-tier]').forEach(function(t){
      var on = parseInt(t.getAttribute('data-mp-tier'),10) === n;
      t.classList.toggle('on', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    renderSlots(sid);
    mpTotal(sid);
    offerUI(sid);
  };

  /* ---------- offer ladder: free items per tier, labels, sticky bar ---------- */
  function tierEl(sid){
    var c = cfg(sid), r = root(sid); if(!c || !r) return null;
    return r.querySelector('[data-mp-tier="'+c.tier+'"]');
  }
  function giftsOf(t){
    if(!t) return [];
    try { return JSON.parse(t.getAttribute('data-gifts') || '[]') || []; } catch(e){ return []; }
  }
  function giftVariant(c, g){
    c.giftPick = c.giftPick || {};
    var picked = c.giftPick[g.pid], first = null;
    for(var k=0;k<g.v.length;k++){
      if(String(g.v[k].id) === String(picked) && g.v[k].a) return g.v[k];
      if(!first && g.v[k].a) first = g.v[k];
    }
    return first;
  }
  function withOf(t){
    if(!t) return [];
    try { return JSON.parse(t.getAttribute('data-with') || '[]') || []; } catch(e){ return []; }
  }
  /* How many of each flavour a free item adds. Single-quantity gifts use the
     one picked chip; multi-quantity gifts (e.g. 3 free flavours) keep a count
     per flavour that always sums to the gift's quantity. */
  function giftAlloc(c, g){
    var q = g.q || 1;
    if(q <= 1){ var v = giftVariant(c, g); return v ? [{v: v, n: 1}] : []; }
    c.giftMulti = c.giftMulti || {};
    var avail = g.v.filter(function(v){ return v.a; });
    if(!avail.length) return [];
    /* one of each flavour, nothing to choose: no picker for this tier */
    if(autoMix(c, g)) return avail.map(function(v){ return {v: v, n: 1}; });
    var m = c.giftMulti[g.pid];
    if(!m){
      m = {};
      for(var i=0;i<q;i++){ var vv = avail[i % avail.length]; m[vv.id] = (m[vv.id]||0) + 1; }
      c.giftMulti[g.pid] = m;
    }
    return avail.filter(function(v){ return m[v.id] > 0; }).map(function(v){ return {v: v, n: m[v.id]}; });
  }
  function autoMix(c, g){
    if(!c.autoMix || (g.q || 1) <= 1) return false;
    return g.v.filter(function(v){ return v.a; }).length === g.q;
  }
  window.mpGiftStep = function(sid, pid, vid, d){
    var c = cfg(sid); if(!c) return;
    var g = giftsOf(tierEl(sid)).filter(function(x){ return String(x.pid) === String(pid); })[0];
    if(!g) return;
    giftAlloc(c, g);
    var m = c.giftMulti[pid], sum = 0, k;
    for(k in m) sum += m[k];
    var cur = m[vid] || 0;
    if(d > 0 && sum >= g.q){
      /* full: take one from the flavour with the most, so a tap always does something */
      var top = null;
      for(k in m){ if(String(k) !== String(vid) && m[k] > 0 && (top === null || m[k] > m[top])) top = k; }
      if(top === null) return;
      m[top]--; m[vid] = cur + 1;
    } else if(d > 0){ m[vid] = cur + 1; }
    else if(cur > 0){ m[vid] = cur - 1; }
    renderGifts(sid);
  };
  function esc(t){ return String(t == null ? '' : t).replace(/[&<>"]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; }); }
  function renderGifts(sid){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    var box = r.querySelector('[data-mp-gp]'); if(!box) return;
    var multi = giftsOf(tierEl(sid)).filter(function(g){ return g.v && g.v.length > 1 && !autoMix(c, g); });
    if(!multi.length){ box.hidden = true; box.innerHTML = ''; return; }
    var label = box.getAttribute('data-label') || 'Pick your free flavor';
    var labelN = box.getAttribute('data-label-n') || 'Pick your {n} free flavors';
    box.innerHTML = multi.map(function(g){
      if((g.q || 1) > 1){
        var al = giftAlloc(c, g), cnt = {}, tot = 0;
        al.forEach(function(a){ cnt[a.v.id] = a.n; tot += a.n; });
        return '<p class="mp-gp-h">' + esc(labelN.replace('{n}', g.q)) + ' <span class="mp-gp-cnt' + (tot < g.q ? ' short' : '') + '">' + tot + '/' + g.q + '</span></p><div class="mp-gp-row mp-gp-row--n">' + g.v.map(function(v){
          var n = cnt[v.id] || 0;
          return '<div class="mp-gp-n' + (n ? ' on' : '') + (v.a ? '' : ' off') + '">' +
                 (v.img ? '<img src="' + esc(v.img) + '" alt="">' : '') + '<span class="mp-gp-nt">' + esc(v.t) + '</span>' +
                 (v.a ? '<span class="mp-gp-st"><button type="button" aria-label="One less ' + esc(v.t) + '" onclick="mpGiftStep(\'' + sid + '\',' + g.pid + ',' + v.id + ',-1)">&minus;</button><b>' + n + '</b><button type="button" aria-label="One more ' + esc(v.t) + '" onclick="mpGiftStep(\'' + sid + '\',' + g.pid + ',' + v.id + ',1)">+</button></span>' : '<small>Sold out</small>') +
                 '</div>';
        }).join('') + '</div>';
      }
      var cur = giftVariant(c, g);
      return '<p class="mp-gp-h">' + esc(label) + '</p><div class="mp-gp-row">' + g.v.map(function(v){
        var on = cur && String(cur.id) === String(v.id);
        return '<button type="button" class="mp-gp-o' + (on ? ' on' : '') + '"' + (v.a ? '' : ' disabled') +
               ' aria-pressed="' + (on ? 'true' : 'false') + '" onclick="mpGift(\'' + sid + '\',' + g.pid + ',' + v.id + ')">' +
               (v.img ? '<img src="' + esc(v.img) + '" alt="">' : '') + '<span>' + esc(v.t) + '</span>' +
               (v.a ? '' : '<small>Sold out</small>') + '</button>';
      }).join('') + '</div>';
    }).join('');
    box.hidden = false;
  }
  window.mpGift = function(sid, pid, vid){
    var c = cfg(sid); if(!c) return;
    c.giftPick = c.giftPick || {};
    c.giftPick[pid] = vid;
    renderGifts(sid);
  };
  window.mpBumpUI = function(sid){
    var r = root(sid), t = tierEl(sid); if(!r) return;
    var b = r.querySelector('#mpBump-'+sid), l = r.querySelector('[data-mp-atc-l]');
    if(!b || !l) return;
    var lab = b.closest('.bump'), only = lab ? lab.getAttribute('data-bump-tier') : '';
    if(only){
      var c0 = cfg(sid), show = c0 && String(c0.tier) === String(only);
      lab.hidden = !show;
      if(!show && b.checked){ b.checked = false; mpTotal(sid); }
    }
    var on = b.checked && b.getAttribute('data-atc-on');
    r.querySelector('.bump') && r.querySelector('.bump').classList.toggle('on', !!b.checked);
    l.textContent = on ? b.getAttribute('data-atc-on') : ((t && t.getAttribute('data-atc')) || l.getAttribute('data-default') || l.textContent);
  };
  function setText(el, txt){ if(!el) return; el.textContent = txt || ''; el.hidden = !txt; }
  function offerUI(sid){
    var r = root(sid), t = tierEl(sid); if(!r || !t) return;
    var l = r.querySelector('[data-mp-atc-l]');
    if(l) l.textContent = t.getAttribute('data-atc') || l.getAttribute('data-default') || l.textContent;
    setText(r.querySelector('[data-mp-tnote]'), t.getAttribute('data-note'));
    setText(r.querySelector('[data-mp-nudge]'), t.getAttribute('data-nudge'));
    var sv = r.querySelector('[data-mp-save]');
    if(sv){
      var cents = parseInt(t.getAttribute('data-save'), 10) || 0;
      var c = cfg(sid);
      sv.innerHTML = esc(sv.getAttribute('data-tpl') || '').replace('{amount}', money(cents, c.moneySample));
      sv.hidden = !(cents > 0);
    }
    var bar = document.querySelector('.mp-sticky[data-mp-sid="'+sid+'"]') || r.querySelector('[data-mp-sticky]');
    if(bar){
      var sl = bar.querySelector('[data-mp-st-l]'), ss = bar.querySelector('[data-mp-st-s]');
      if(sl) sl.textContent = t.getAttribute('data-label') || '';
      if(ss) ss.textContent = t.getAttribute('data-ship') || '';
    }
    renderGifts(sid);
    mpBumpUI(sid);
  }
  function packFromHash(h){ var m = /#pack-(\d)/.exec(h || ''); return m ? parseInt(m[1], 10) : 0; }
  function goPack(n){
    var t = document.querySelector('[data-mp] [data-mp-tier="'+n+'"]');
    if(!t) return false;
    var host = t.closest('[data-mp]'), sid = host.getAttribute('data-mp');
    mpTier(sid, n);
    var bb = host.querySelector('.bb') || t;
    try { bb.scrollIntoView({block:'center', behavior:'smooth'}); } catch(e){ bb.scrollIntoView(); }
    return true;
  }
  if(!window.__mpPackLinks){
    window.__mpPackLinks = true;
    document.addEventListener('click', function(e){
      var a = e.target && e.target.closest ? e.target.closest('a[href*="#pack-"]') : null;
      if(!a) return;
      var n = packFromHash(a.getAttribute('href'));
      if(n && goPack(n)) e.preventDefault();
    });
  }
  function stickyInit(r, sid){
    var bar = r.querySelector('[data-mp-sticky]'), atc = r.querySelector('.mp-atc');
    if(!bar || !atc) return;
    var old = document.querySelector('body > .mp-sticky[data-mp-sid="'+sid+'"]');
    if(old && old !== bar) old.parentNode.removeChild(old);
    bar.setAttribute('data-mp-sid', sid);
    document.body.appendChild(bar);
    var ticking = false;
    function chk(){
      ticking = false;
      bar.classList.toggle('show', atc.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(chk); } }, {passive:true});
    chk();
  }

  /* ---------- total ---------- */
  window.mpTotal = function(sid){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    var tier = r.querySelector('[data-mp-tier="'+c.tier+'"]'); if(!tier) return;
    var cents = parseInt(tier.getAttribute('data-cents'),10) || 0;
    var bump = r.querySelector('#mpBump-'+sid);
    if(bump && bump.checked) cents += parseInt(bump.getAttribute('data-cents'),10) || 0;
    /* innerHTML, not textContent: moneySample comes from {{ 100000 | money }},
       and the shop's money format wraps amounts in <span class=cvc-money> for
       the currency app — textContent would print that markup to the customer.
       The sticky bar is moved to <body>, so it is looked up there too. */
    var html = money(cents, c.moneySample);
    r.querySelectorAll('[data-mp-total]').forEach(function(o){ o.innerHTML = html; });
    var st = document.querySelector('.mp-sticky[data-mp-sid="'+sid+'"] [data-mp-total]');
    if(st) st.innerHTML = html;
  };

  /* Message for the Buy-on-WhatsApp button. Built from the same cfg the
     add-to-cart uses, so what lands in the inbox can never drift from what the
     customer actually configured: tier quantity, chosen flavours, live total.
     Reads the price from [data-mp-total] with textContent, not innerHTML, so the
     currency app's <span class=cvc-money> wrapper never reaches the message. */
  window.mpWaText = function(sid){
    var c = cfg(sid), r = root(sid);
    if(!c || !r) return '';
    var parts = [];
    if(c.title) parts.push(c.title);

    var tier = r.querySelector('[data-mp-tier="'+c.tier+'"]');
    var qty = tier ? (parseInt(tier.getAttribute('data-qty'),10) || 1) : 1;
    if(qty > 1) parts.push(qty + ' packs');

    if(c.hasVariants){
      var chosen = (c.slots[c.tier] || []).map(function(id){
        var v = byId(c, id); return v ? vt(v) : null;
      }).filter(Boolean);
      if(chosen.length) parts.push(chosen.join(', '));
    }

    withOf(tier).forEach(function(w){ parts.push(qty + ' x ' + w.t); });
    var free = giftsOf(tier).map(function(g){
      var al = giftAlloc(c, g);
      var picks = g.v.length > 1 ? ' (' + al.map(function(a){ return (a.n > 1 ? a.n + ' ' : '') + a.v.t; }).join(', ') + ')' : '';
      return 'FREE ' + ((g.q || 1) > 1 ? g.q + ' x ' : '') + g.t + picks;
    });
    if(free.length) parts.push(free.join(' + '));

    var out = r.querySelector('[data-mp-total]');
    var price = out ? (out.textContent || '').trim() : '';
    if(price) parts.push(price);

    return 'Hi Energyze, I would like to order: ' + parts.join(' — ');
  };

  /* ---------- add to cart ---------- */
  function post(items, btn, label){
    btn.disabled = true;
    var original = label;
    btn.textContent = 'Adding…';
    return fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items: items})
    }).then(function(res){
      btn.disabled = false;
      if(res.ok){
        btn.innerHTML = original;
        try { if(window.ezbCartAdded) ezbCartAdded(); else window.location.href='/cart'; }
        catch(e){ window.location.href='/cart'; }
        return;
      }
      return res.json().catch(function(){ return {}; }).then(function(b){
        var msg = (b && (b.description || b.message)) || '';
        var txt = res.status === 422
          ? (/can add|already|only have|items? in your cart/i.test(msg) ? 'Max in cart' : 'Sold out')
          : 'Try again';
        btn.textContent = txt;
        setTimeout(function(){ btn.innerHTML = original; }, 2600);
      });
    }).catch(function(){
      btn.disabled = false;
      btn.textContent = 'Try again';
      setTimeout(function(){ btn.innerHTML = original; }, 2600);
    });
  }

  window.mpAdd = function(sid, btn){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    var tier = r.querySelector('[data-mp-tier="'+c.tier+'"]'); if(!tier) return;
    var qty = parseInt(tier.getAttribute('data-qty'),10) || 1;
    var agg = {};
    if(c.hasVariants){
      var chosen = (c.slots[c.tier]||[]).slice(0, qty);
      var missing = -1;
      for(var k=0;k<qty;k++) if(!chosen[k]){ missing = k; break; }
      if(missing > -1){
        /* Don't silently add a flavour the customer never picked. */
        r.querySelectorAll('.mp-cir').forEach(function(b){
          if(!b.classList.contains('filled')){
            b.classList.add('err');
            setTimeout(function(){ b.classList.remove('err'); }, 1200);
          }
        });
        mpOpen(sid, missing);
        r.querySelector('[data-mp-vp]').scrollIntoView({block:'center', behavior:'smooth'});
        return;
      }
      chosen.forEach(function(id){ agg[id] = (agg[id]||0)+1; });
    } else {
      agg[c.defaultVariant] = qty;
    }
    /* every free flavour must be picked before the pack goes in the cart */
    var short = giftsOf(tier).some(function(g){
      if((g.q || 1) <= 1) return false;
      return giftAlloc(c, g).reduce(function(s2, a){ return s2 + a.n; }, 0) < g.q;
    });
    if(short){
      var gp = r.querySelector('[data-mp-gp]');
      if(gp){
        gp.classList.add('err'); setTimeout(function(){ gp.classList.remove('err'); }, 1200);
        try { gp.scrollIntoView({block:'center', behavior:'smooth'}); } catch(e){}
      }
      return;
    }
    var req = [c.productId + ':' + qty];
    withOf(tier).forEach(function(w){
      if(w.vid){ agg[w.vid] = (agg[w.vid]||0) + qty; req.push(w.pid + ':' + qty); }
    });
    var items = Object.keys(agg).map(function(id){ return {id: parseInt(id,10), quantity: agg[id]}; });
    var packName = tier.getAttribute('data-label') || 'pack';
    giftsOf(tier).forEach(function(g){
      giftAlloc(c, g).forEach(function(a){
        items.push({id: a.v.id, quantity: a.n, properties: {_offer: packName, _offer_req: req.join(','), _offer_q: String(a.n)}});
      });
    });
    var bump = r.querySelector('#mpBump-'+sid);
    if(bump && bump.checked && bump.getAttribute('data-vid')) items.push({id: parseInt(bump.getAttribute('data-vid'),10), quantity:1});
    post(items, btn, btn.innerHTML);
  };

  /* Jump to the reviews section, clearing the sticky header. Falls back to the
     browser's own anchor handling if the target isn't on this page. */
  window.mpJump = function(a){
    var id = (a.getAttribute('href') || '').replace(/^.*#/, '');
    if(!id) return true;
    var el = document.getElementById(id) ||
             document.querySelector('.reviews, [data-reviews], #shopify-block-reviews');
    if(!el) return true;
    var head = document.querySelector('.site-header, .header, header');
    var off  = head ? head.getBoundingClientRect().height + 16 : 24;
    var top   = el.getBoundingClientRect().top + window.pageYOffset - off;
    var start = window.pageYOffset;
    try { window.scrollTo({ top: top, behavior: 'smooth' }); }
    catch(e){ window.scrollTo(0, top); }
    /* Smooth scrolling is a no-op in some contexts; make sure the jump still lands. */
    setTimeout(function(){
      if(Math.abs(window.pageYOffset - start) < 4) window.scrollTo(0, top);
    }, 260);
    return false;
  };

  /* Accordion rows. Animating an explicit measured height, then releasing to auto,
     so a row still opens correctly if its content reflows (images, tables, fonts). */
  function accSet(row, open, animate){
    var body = row.querySelector('.mp-acc-b');
    var btn  = row.querySelector('.mp-acc-h');
    row.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    clearTimeout(row._t);
    if(!animate){ body.style.height = open ? 'auto' : '0px'; return; }
    var target = body.scrollHeight;
    if(open){
      body.style.height = '0px';
      void body.offsetHeight;               /* commit the start height */
      body.style.height = target + 'px';
      row._t = setTimeout(function(){
        if(row.classList.contains('is-open')) body.style.height = 'auto';
      }, 300);
    } else {
      body.style.height = target + 'px';
      void body.offsetHeight;               /* pin the pixel height before collapsing */
      body.style.height = '0px';
    }
  }
  window.mpAcc = function(btn){
    var row = btn.closest('.mp-acc');
    accSet(row, !row.classList.contains('is-open'), true);
  };

  window.mpUp = function(vid, btn){
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: vid, quantity:1}]})
    }).then(function(res){
      btn.classList.remove('is-loading');
      if(res.ok && window.ezbCartAdded) ezbCartAdded();
      else if(res.ok) window.location.href='/cart';
    }).catch(function(){ btn.classList.remove('is-loading'); });
  };

  function boot(){
    document.querySelectorAll('[data-mp]').forEach(function(r){
      var sid = r.getAttribute('data-mp');
      var c = cfg(sid); if(!c) return;
      stickyInit(r, sid);
      renderSlots(sid);
      mpTotal(sid);
      offerUI(sid);
      r.querySelectorAll('.mp-acc').forEach(function(row){
        accSet(row, row.classList.contains('is-open'), false);
      });
    });
  }
  function bootAll(){
    boot();
    var n = packFromHash(location.hash);
    if(n) goPack(n);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
